import { render, staticRenderFns } from "./ScoringProfilesDetails.vue?vue&type=template&id=5171e75f&scoped=true"
import script from "./ScoringProfilesDetails.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesDetails.vue?vue&type=script&lang=js"
import style0 from "./ScoringProfilesDetails.vue?vue&type=style&index=0&id=5171e75f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5171e75f",
  null
  
)

export default component.exports